import React from "react";

const AddCouncil = () => {
  return <div>AddCouncil</div>;
};

export default AddCouncil;
